import React from 'react';
import { Link } from 'react-router-dom';
import '../index.scss';

// Native Link navigation preserves router state, modifier keys and document reloads.
// Press feedback is CSS-only, so leaving a screen cannot schedule a second navigation.
export const AnimatedLink = ({ className = '', ...props }) => (
  <Link className={`animated-link wiw-icon-link ${className}`} {...props} />
);
